module.exports = __webpack_public_path__ + "static/media/typing.a85e353a.jpg";